import { Box, Modal, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  addToExternalReferralAccesses,
  addWareHouseAccesses,
  getGroupsUsers,
} from "../../../api/group";
import userPic from "../../../assets/image/user-profile3.png";
import AutoComplate from "../../autocomplete/autoComplate";

export default function NewUser({ open, setOpen, equipment, erja }) {
  const [Options, setOptions] = useState();
  const [userInfo, setUserInfo] = useState();
  const [dataNewUser, setDataNewUser] = useState({
    userId: "",
    drugAccess: true,
    // equipmentAccess: false,
  });
  useEffect(() => {
    if (equipment) {
      setDataNewUser({
        userId: "",
        // drugAccess: false,
        equipmentAccess: true,
      });
    }
  }, [equipment]);
  //   const [open, setOpen] = useState(false);
  //   const handleOpen = () => setOpen(true);
  const handleClose = () => {
    // setShow(false);
    setOpen(false);
  };
  useEffect(() => {
    if (open === true) {
      getGroupsUsers()
        .then((x) => setOptions(x))
        .catch((z) => console.log(z));
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      //   sx={{}}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 750,
          height: 350,
          bgcolor: "white",
          boxShadow: 24,
          p: 5,
          borderRadius: "23px",
          ":focus-visible": {
            outline: "none !important",
            border: "none !important",
          },
        }}
      >
        <Box display="flex" alignItems="center" gap="20px">
          <Box width="40%" borderLeft="1px solid #98C2CB" height={"350px"}>
            <img src={userPic} />
          </Box>
          <Box display="grid" height="300px" pl="20px">
            <Box>
              <Typography fontSize="18px">
                {"اجازه دسترسی به کاربر جدید"}
              </Typography>
              {erja ? (
                <Typography
                  mt="10px"
                  color="var(--emr-disable)"
                  fontSize="16px"
                >
                  {
                    "اگر میخواهید فرد جدیدی به سرویس ارجاع دسترسی کامل داشته باشد، نام فرد را در فرم پایین جستجو کنید و گزینه تایید را کلیک کنید."
                  }
                </Typography>
              ) : (
                <Typography
                  mt="10px"
                  color="var(--emr-disable)"
                  fontSize="16px"
                >
                  {
                    "اگر میخواهید فرد جدیدی به سرویس انبار داروخانه دسترسی کامل داشته باشد، نام فرد را در فرم پایین جستجو کنید و گزینه تایید را کلیک کنید."
                  }
                </Typography>
              )}
            </Box>
            <Box mx="20px" my="20px">
              {/* <InputForm
              value={value}
              setValue={setValue}
                Options={Options}
                placeholder="مسئول گروه را انتخاب کنید."
                lable="مسئول گروه"
              /> */}
              <AutoComplate
                // value={userInfo}
                setValue={(e, newValue) =>
                  setDataNewUser({ ...dataNewUser, userId: e?.id })
                }
                label="کاربر جدید"
                placeholder="کاربر جدید را انتخاب کنید."
                options={Options}
                // onChange={(e, newValue) => console.log(newValue)}
              />
            </Box>
            <button
              onClick={() => {
                if (erja) {
                  addToExternalReferralAccesses(dataNewUser?.userId)
                    .then(() => {
                      setOpen(false);
                    })
                    .catch(() => {});
                } else {
                  addWareHouseAccesses(dataNewUser)
                    .then(() => {
                      setOpen(false);
                    })
                    .catch(() => {});
                }
              }}
              style={{
                borderRadius: "7px",
                background: "#126E83",
                border: "none",
                // padding: "5px 0px",
                marginTop: "5px",
                fontSize: "20px",
                color: "white",
              }}
            >
              {"تایید درخواست"}
            </button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
